import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Home.css';

const Home: React.FC = () => {
  const { token } = useAuth();
  const navigate = useNavigate();

  if (token) {
    navigate('/browse');
    return null;
  }

  return (
    <div className="home-container">
      <div className="home-content">
        <h1 className="home-title">Two Him</h1>
        <p className="home-subtitle">Where Meaningful Connections Begin</p>

        <div className="home-features">
          <div className="feature">
            <h3>💖 Authentic Profiles</h3>
            <p>Create your unique profile and connect with others</p>
          </div>
          <div className="feature">
            <h3>💚 Smart Matching</h3>
            <p>Find your perfect match with our intelligent system</p>
          </div>
          <div className="feature">
            <h3>💬 Real-time Chat</h3>
            <p>Connect instantly with your matches</p>
          </div>
        </div>

        <div className="home-actions">
          <button onClick={() => navigate('/register')} className="primary-button">
            Get Started
          </button>
          <button onClick={() => navigate('/login')} className="secondary-button">
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
